import Spinner from '@/components/global/Spinner/Spinner';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  useGetServiceLevelDefinitionByIdQuery,
  useListServiceLevelDefinitionClassifiersQuery,
} from 'redux/services/generate/configurations/serviceLevelDefinitions';
import { useLocalizedNavigate } from 'util/hooks';
import { routes } from 'util/routes';
import NotFoundPage from '../../NotFoundPage/NotFoundPage';
import ServiceLevelForm from './ServiceLevelForm/ServiceLevelForm';
import styles from './ServiceLevelFormPage.module.css';
import { mapServiceLevelToFormValues } from './mapServiceLevelToFormValues';
import { defaultServiceLevelFormValues } from '../serviceLevelOptions';

function ServiceLevelFormPage() {
  const { serviceLevelId } = useParams();
  const navigate = useLocalizedNavigate();

  const editingServiceLevelId =
    serviceLevelId === undefined ? undefined : Number(serviceLevelId);
  const isEditMode = editingServiceLevelId !== undefined;
  const hasInvalidServiceLevelId =
    editingServiceLevelId !== undefined &&
    (!Number.isInteger(editingServiceLevelId) || editingServiceLevelId <= 0);

  const {
    data: serviceLevel,
    isFetching: isFetchingServiceLevel,
    isError,
  } = useGetServiceLevelDefinitionByIdQuery(
    { recId: editingServiceLevelId ?? 0 },
    {
      skip: !isEditMode || hasInvalidServiceLevelId,
    },
  );
  const { data: classifiers, isFetching: isFetchingClassifiers } =
    useListServiceLevelDefinitionClassifiersQuery(undefined, {
      skip: !isEditMode || hasInvalidServiceLevelId,
    });

  const formData = useMemo(() => {
    if (!isEditMode || !serviceLevel) {
      return defaultServiceLevelFormValues;
    }

    return mapServiceLevelToFormValues(serviceLevel, classifiers);
  }, [classifiers, isEditMode, serviceLevel]);

  if (hasInvalidServiceLevelId) {
    return <NotFoundPage />;
  }

  if (isEditMode && (isFetchingServiceLevel || isFetchingClassifiers)) {
    return <Spinner position="centerAbsolute" size="large" />;
  }

  if (isEditMode && (isError || !serviceLevel)) {
    return <NotFoundPage />;
  }

  const closeForm = () => {
    void navigate(routes.serviceLevels.to());
  };

  return (
    <section className={styles.pageWrapper}>
      <div className={styles.page}>
        <ServiceLevelForm
          formData={formData}
          onClose={closeForm}
          editingServiceLevelId={editingServiceLevelId}
        />
      </div>
    </section>
  );
}

export default ServiceLevelFormPage;
